<template>
  <div class="ExamOnline">
    <TopNavBar navtitle="上传视频"></TopNavBar>
    <div class="enrolllist" v-if="ExamFromInfo">
      <ul class="examinfo">
        <h1>{{ ExamFromInfo.ExamBatch.EB_Name }}</h1>
        <img
          class="papers"
          :src="ExamFromInfo.Photo"
          :alt="ExamFromInfo.Name"
        />
        <li>
          <label for="">姓名：</label>
          <span>{{ ExamFromInfo.Name }}</span>
        </li>
        <li>
          <label for="">准考证号：</label>
          <span>{{ ExamFromInfo.ExamNO }}</span>
        </li>
        <li>
          <label for="">专业：</label>
          <span class="warning">{{ ExamFromInfo.Majors.MName }}</span>
        </li>
        <li>
          <label for="">级别：</label>
          <span class="warning">{{ ExamFromInfo.Grades.GName }}</span>
        </li>
      </ul>
      <ul class="examask">
        <h1>
          考试项目：{{ ExamFromInfo.Majors.MName }}
          {{ ExamFromInfo.Grades.GName }}
        </h1>
        <p class="small">注：各科按本专业实际要求的内容上传。</p>
        <p class="danger small">
          上传视频起止日期：{{ ExamFromInfo.ExamTime.ExamBeginDate }} 至
          {{ ExamFromInfo.ExamTime.ExamEndDate }}
        </p>
        <p class="danger" v-if="IsSub == 0">
          本次操作倒计时
          <van-count-down
            :time="
              (ExamFromInfo.Grades.UploadTime != 0
                ? ExamFromInfo.Grades.UploadTime
                : 60) *
                60 *
                1000
            "
            @finish="finish"
            :auto-start="false"
            ref="timer"
          />
        </p>
        <div
          v-if="
            ExamPatternList &&
              ExamPatternList.filter(
                s =>
                  s.EQT_ID == 1 ||
                  s.EQT_ID == 6 ||
                  s.EQT_ID == 10 ||
                  s.EQT_ID == 23 ||
                  s.EQT_ID == 24 ||
                  s.EQT_ID == 30
              )
          "
        >
          <div
            v-for="PatternInfo in ExamPatternList.filter(
              s =>
                s.EQT_ID == 1 ||
                s.EQT_ID == 6 ||
                s.EQT_ID == 10 ||
                s.EQT_ID == 23 ||
                s.EQT_ID == 24 ||
                s.EQT_ID == 30
            )"
            :key="PatternInfo.EP_ID"
          >
            <div v-if="PatternInfo.IsRandom == 1">
              <li
                v-for="n in PatternInfo.SubmitNum"
                :key="PatternInfo.EP_ID + n"
              >
                <p
                  v-if="
                    !AnswerSheetList ||
                      AnswerSheetList.length == 0 ||
                      AnswerSheetList.filter(
                        s =>
                          s.ExamQuestionType.EQT_ID ==
                          PatternInfo.ExamQuestionType.EQT_ID
                      ).length < n
                  "
                >
                  <label for=""
                    >{{ PatternInfo.ExamQuestionType.TypeName }}({{
                      chin_list[n - 1]
                    }})</label
                  >
                  <van-button
                    type="info"
                    plain
                    round
                    size="small"
                    @click="RandomQuestion(PatternInfo.EP_ID)"
                    >点击查看考试内容</van-button
                  >
                </p>
                <div
                  v-if="
                    AnswerSheetList &&
                      AnswerSheetList.length > 0 &&
                      AnswerSheetList.filter(
                        s =>
                          s.ExamQuestionType.EQT_ID ==
                          PatternInfo.ExamQuestionType.EQT_ID
                      ).length >= n &&
                      AnswerSheetList.filter(
                        s =>
                          s.ExamQuestionType.EQT_ID ==
                          PatternInfo.ExamQuestionType.EQT_ID
                      )[n - 1].Answer == ''
                  "
                >
                  <p>
                    <label for=""
                      >{{
                        AnswerSheetList.filter(
                          s =>
                            s.ExamQuestionType.EQT_ID ==
                            PatternInfo.ExamQuestionType.EQT_ID
                        )[n - 1].ExamQuestionType.TypeName
                      }}({{ chin_list[n - 1] }})</label
                    >
                    <span class="refer">
                      {{
                        AnswerSheetList.filter(
                          s =>
                            s.ExamQuestionType.EQT_ID ==
                            PatternInfo.ExamQuestionType.EQT_ID
                        )[n - 1].View_ExamQuestion.Question
                      }}
                    </span>
                    <van-button
                      type="primary"
                      plain
                      size="small"
                      v-if="
                        AnswerSheetList.filter(
                          s =>
                            s.ExamQuestionType.EQT_ID ==
                            PatternInfo.ExamQuestionType.EQT_ID
                        )[n - 1].View_ExamQuestion.MusicType == 2 &&
                          AnswerSheetList.filter(
                            s =>
                              s.ExamQuestionType.EQT_ID ==
                              PatternInfo.ExamQuestionType.EQT_ID
                          )[n - 1].View_ExamQuestion.MusicScore != ''
                      "
                      @click="
                        ShowMusicScore(
                          AnswerSheetList.filter(
                            s =>
                              s.ExamQuestionType.EQT_ID ==
                              PatternInfo.ExamQuestionType.EQT_ID
                          )[n - 1].View_ExamQuestion.MusicScore
                        )
                      "
                      >查看曲谱</van-button
                    >
                    <van-button
                      type="primary"
                      plain
                      size="small"
                      v-if="
                        AnswerSheetList.filter(
                          s =>
                            s.ExamQuestionType.EQT_ID ==
                            PatternInfo.ExamQuestionType.EQT_ID
                        )[n - 1].View_ExamQuestion.MusicType == 3 &&
                          AnswerSheetList.filter(
                            s =>
                              s.ExamQuestionType.EQT_ID ==
                              PatternInfo.ExamQuestionType.EQT_ID
                          )[n - 1].View_ExamQuestion.MusicScore != ''
                      "
                      :url="
                        AnswerSheetList.filter(
                          s =>
                            s.ExamQuestionType.EQT_ID ==
                            PatternInfo.ExamQuestionType.EQT_ID
                        )[n - 1].View_ExamQuestion.MusicScore
                      "
                      >查看视频</van-button
                    >
                    <van-button
                      type="primary"
                      plain
                      size="small"
                      v-if="
                        AnswerSheetList.filter(
                          s =>
                            s.ExamQuestionType.EQT_ID ==
                            PatternInfo.ExamQuestionType.EQT_ID
                        )[n - 1].View_ExamQuestion.MusicType == 1 &&
                          AnswerSheetList.filter(
                            s =>
                              s.ExamQuestionType.EQT_ID ==
                              PatternInfo.ExamQuestionType.EQT_ID
                          )[n - 1].View_ExamQuestion.MusicScore != ''
                      "
                      :url="
                        AnswerSheetList.filter(
                          s =>
                            s.ExamQuestionType.EQT_ID ==
                            PatternInfo.ExamQuestionType.EQT_ID
                        )[n - 1].View_ExamQuestion.MusicScore
                      "
                      >查看视频</van-button
                    >
                  </p>
                  <p>
                    <span
                      v-if="
                        AnswerSheetList &&
                          new Date(
                            AnswerSheetList.filter(
                              s =>
                                s.ExamQuestionType.EQT_ID ==
                                PatternInfo.ExamQuestionType.EQT_ID
                            )[n - 1].EndTime.replace(/-/g, '/')
                          ) > new Date()
                      "
                      class="warning"
                    >
                      视频未上传
                      <!-- <van-count-down :time="(new Date(AnswerSheetList.filter(s=>s.ExamQuestionType.EQT_ID==PatternInfo.ExamQuestionType.EQT_ID)[n-1].EndTime.replace(/-/g, '/')).getTime()) - (new Date().getTime()) " /> -->
                    </span>
                    <span v-else class="warning">
                      上传时间已结束，禁止上传视频！
                    </span>
                    <van-uploader
                      :max-count="1"
                      v-if="
                        IsSub == 0 &&
                          new Date(
                            AnswerSheetList.filter(
                              s =>
                                s.ExamQuestionType.EQT_ID ==
                                PatternInfo.ExamQuestionType.EQT_ID
                            )[n - 1].EndTime.replace(/-/g, '/')
                          ) > new Date()
                      "
                      :before-read="beforeRead"
                      capture="camera"
                      :name="
                        AnswerSheetList.filter(
                          s =>
                            s.ExamQuestionType.EQT_ID ==
                            PatternInfo.ExamQuestionType.EQT_ID
                        )[n - 1].EAS_ID + '|0|0'
                      "
                      accept="video/*"
                    >
                      <van-button type="info" round size="small"
                        ><i class="iconfont icon-shangchuanshipin1"></i
                        >拍摄视频</van-button
                      >
                    </van-uploader>
                  </p>
                </div>
                <div
                  v-if="
                    AnswerSheetList &&
                      AnswerSheetList.length > 0 &&
                      AnswerSheetList.filter(
                        s =>
                          s.ExamQuestionType.EQT_ID ==
                          PatternInfo.ExamQuestionType.EQT_ID
                      ).length >= n &&
                      AnswerSheetList.filter(
                        s =>
                          s.ExamQuestionType.EQT_ID ==
                          PatternInfo.ExamQuestionType.EQT_ID
                      )[n - 1].Answer != ''
                  "
                >
                  <p>
                    <label for=""
                      >{{
                        AnswerSheetList.filter(
                          s =>
                            s.ExamQuestionType.EQT_ID ==
                            PatternInfo.ExamQuestionType.EQT_ID
                        )[n - 1].ExamQuestionType.TypeName
                      }}({{ chin_list[n - 1] }})</label
                    >

                    <span class="refer">
                      {{
                        AnswerSheetList.filter(
                          s =>
                            s.ExamQuestionType.EQT_ID ==
                            PatternInfo.ExamQuestionType.EQT_ID
                        )[n - 1].View_ExamQuestion.Question
                      }}
                    </span>
                  </p>
                  <p>
                    <span class="gray">
                      <van-loading
                        size="3.2vw"
                        color="#1989fa"
                        type="spinner"
                        v-if="
                          AnswerSheetList.filter(
                            s =>
                              s.ExamQuestionType.EQT_ID ==
                              PatternInfo.ExamQuestionType.EQT_ID
                          )[n - 1].Similarity == 0
                        "
                        vertical
                        ><span class="small">人脸识别中...</span></van-loading
                      >
                      <van-tag
                        type="success"
                        v-if="
                          AnswerSheetList.filter(
                            s =>
                              s.ExamQuestionType.EQT_ID ==
                              PatternInfo.ExamQuestionType.EQT_ID
                          )[n - 1].Similarity >= 0.7 &&
                            AnswerSheetList.filter(
                              s =>
                                s.ExamQuestionType.EQT_ID ==
                                PatternInfo.ExamQuestionType.EQT_ID
                            )[n - 1].Similarity <= 1
                        "
                      >
                        <h5>
                          相似度{{
                            Number(
                              AnswerSheetList.filter(
                                s =>
                                  s.ExamQuestionType.EQT_ID ==
                                  PatternInfo.ExamQuestionType.EQT_ID
                              )[n - 1].Similarity * 100
                            ).toFixed()
                          }}%
                        </h5>
                        <h5>识别通过</h5>
                      </van-tag>
                      <van-tag
                        type="warning"
                        v-if="
                          AnswerSheetList.filter(
                            s =>
                              s.ExamQuestionType.EQT_ID ==
                              PatternInfo.ExamQuestionType.EQT_ID
                          )[n - 1].Similarity > 0 &&
                            AnswerSheetList.filter(
                              s =>
                                s.ExamQuestionType.EQT_ID ==
                                PatternInfo.ExamQuestionType.EQT_ID
                            )[n - 1].Similarity < 0.7
                        "
                      >
                        <h5>
                          相似度{{
                            Number(
                              AnswerSheetList.filter(
                                s =>
                                  s.ExamQuestionType.EQT_ID ==
                                  PatternInfo.ExamQuestionType.EQT_ID
                              )[n - 1].Similarity * 100
                            ).toFixed()
                          }}%
                        </h5>
                        <h5>未通过</h5>
                      </van-tag>
                      <van-tag
                        type="danger"
                        v-if="
                          AnswerSheetList.filter(
                            s =>
                              s.ExamQuestionType.EQT_ID ==
                              PatternInfo.ExamQuestionType.EQT_ID
                          )[n - 1].Similarity > 1
                        "
                      >
                        <h5>识别失败！</h5>
                        <h5>未通过</h5>
                      </van-tag>
                    </span>
                    <van-button
                      plain
                      type="info"
                      @click="
                        Viewvideo(
                          AnswerSheetList.filter(
                            s =>
                              s.ExamQuestionType.EQT_ID ==
                              PatternInfo.ExamQuestionType.EQT_ID
                          )[n - 1]
                        )
                      "
                      round
                      size="small"
                      ><i class="iconfont icon-shangchuanshipin"></i
                      >查看视频</van-button
                    >
                    <van-uploader
                      :max-count="1"
                      v-if="
                        IsSub == 0 &&
                          new Date(
                            AnswerSheetList.filter(
                              s =>
                                s.ExamQuestionType.EQT_ID ==
                                PatternInfo.ExamQuestionType.EQT_ID
                            )[n - 1].EndTime.replace(/-/g, '/')
                          ) > new Date()
                      "
                      :before-read="beforeRead"
                      capture="camera"
                      :name="
                        AnswerSheetList.filter(
                          s =>
                            s.ExamQuestionType.EQT_ID ==
                            PatternInfo.ExamQuestionType.EQT_ID
                        )[n - 1].EAS_ID + '|0|0'
                      "
                      accept="video/*"
                    >
                      <van-button type="primary" round size="small"
                        ><i class="iconfont icon-shangchuanshipin1"></i
                        >重新拍摄</van-button
                      >
                    </van-uploader>
                  </p>
                </div>
              </li>
            </div>
          </div>
        </div>

        <div v-for="QuestionInfo in QuestionList" :key="QuestionInfo.EQT_ID">
          <div v-if="AnswerSheetList && AnswerSheetList.length > 0">
            <li
              v-for="(Answer, index) in AnswerSheetList.filter(
                s => s.EQT_ID == QuestionInfo.EQT_ID
              )"
              :key="Answer.EAS_ID"
            >
              <p>
                <label for=""
                  >{{ QuestionInfo.TypeName }}({{ chin_list[index] }})</label
                >
                <span class="refer">
                  <model-list-select
                    :list="QuestionInfo.ExamQuestions"
                    v-model="Answer.EQ_ID"
                    :placeholder="'请选择' + QuestionInfo.TypeName"
                    option-value="EQ_ID"
                    option-text="Question"
                  ></model-list-select>
                </span>
              </p>
              <p v-if="Answer.Answer == ''">
                <span
                  class="danger"
                  v-if="
                    new Date(
                      ExamFromInfo.ExamTime.ExamEndDate.replace(/-/g, '/')
                    ) > new Date()
                  "
                >
                  视频未上传
                </span>
                <span class="warning" v-else>
                  上传时间已结束，禁止上传视频！
                </span>
                <van-uploader
                  :max-count="1"
                  :before-read="beforeRead"
                  capture="camera"
                  :name="Answer.EAS_ID + '|' + Answer.EQ_ID + '|' + EF_ID"
                  accept="video/*"
                  v-if="
                    IsSub == 0 &&
                      new Date(
                        ExamFromInfo.ExamTime.ExamEndDate.replace(/-/g, '/')
                      ) > new Date()
                  "
                >
                  <van-button type="info" round size="small"
                    ><i class="iconfont icon-shangchuanshipin1"></i
                    >拍摄视频</van-button
                  >
                </van-uploader>
              </p>
              <p v-else>
                <span class="gray">
                  <van-loading
                    size="3.2vw"
                    color="#1989fa"
                    type="spinner"
                    v-if="Answer.Similarity == 0"
                    vertical
                    ><span class="small">人脸识别中...</span></van-loading
                  >
                  <van-tag
                    type="success"
                    v-if="Answer.Similarity >= 0.7 && Answer.Similarity <= 1"
                  >
                    <h5>
                      相似度{{ Number(Answer.Similarity * 100).toFixed() }}%
                    </h5>
                    <h5>识别通过</h5>
                  </van-tag>
                  <van-tag
                    type="warning"
                    v-if="Answer.Similarity > 0 && Answer.Similarity < 0.7"
                  >
                    <h5>
                      相似度{{ Number(Answer.Similarity * 100).toFixed() }}%
                    </h5>
                    <h5>未通过</h5>
                  </van-tag>
                  <van-tag type="danger" v-if="Answer.Similarity > 1">
                    <h5>识别失败！</h5>
                    <h5>未通过</h5>
                  </van-tag>
                </span>
                <van-button
                  plain
                  type="info"
                  @click="Viewvideo(Answer)"
                  round
                  size="small"
                  ><i class="iconfont icon-shangchuanshipin"></i
                  >查看视频</van-button
                >

                <van-uploader
                  :max-count="1"
                  :before-read="beforeRead"
                  capture="camera"
                  :name="Answer.EAS_ID + '|' + Answer.EQ_ID + '|' + EF_ID"
                  accept="video/*"
                  v-if="
                    IsSub == 0 &&
                      new Date(
                        ExamFromInfo.ExamTime.ExamEndDate.replace(/-/g, '/')
                      ) > new Date()
                  "
                >
                  <van-button type="primary" round size="small"
                    ><i class="iconfont icon-shangchuanshipin1"></i
                    >重新拍摄</van-button
                  >
                </van-uploader>
              </p>
            </li>
          </div>
          <div v-if="!AnswerSheetList || AnswerSheetList.length == 0">
            <li
              v-for="n in QuestionInfo.InitNum"
              :key="QuestionInfo.EQT_ID + n"
            >
              <p>
                <label for=""
                  >{{ QuestionInfo.TypeName }}({{ chin_list[n - 1] }})</label
                >
                <span class="refer">
                  <model-list-select
                    :list="
                      QuestionInfo.ExamQuestions.filter(f => {
                        return (
                          (getObjectValues(uploader).indexOf(f.EQ_ID) == -1 &&
                            getNames(uploader, f.Question).indexOf(
                              f.Question
                            ) == -1) ||
                          (uploader[QuestionInfo.EQT_ID + '#' + n] &&
                            uploader[QuestionInfo.EQT_ID + '#' + n] == f.EQ_ID)
                        );
                      })
                    "
                    v-model="uploader[QuestionInfo.EQT_ID + '#' + n]"
                    :placeholder="'请选择' + QuestionInfo.TypeName"
                    option-value="EQ_ID"
                    option-text="Question"
                  ></model-list-select>
                </span>
              </p>
              <p>
                <span
                  class="danger"
                  v-if="
                    new Date(
                      ExamFromInfo.ExamTime.ExamEndDate.replace(/-/g, '/')
                    ) > new Date()
                  "
                >
                  视频未上传
                </span>
                <span class="warning" v-else>
                  上传时间已结束，禁止上传视频！
                </span>
                <van-uploader
                  :max-count="1"
                  :before-read="beforeRead"
                  capture="camera"
                  :name="
                    '0|' + uploader[QuestionInfo.EQT_ID + '#' + n] + '|' + EF_ID
                  "
                  accept="video/*"
                  v-if="
                    IsSub == 0 &&
                      uploader[QuestionInfo.EQT_ID + '#' + n] != undefined &&
                      new Date(
                        ExamFromInfo.ExamTime.ExamEndDate.replace(/-/g, '/')
                      ) > new Date()
                  "
                >
                  <van-button type="info" round size="small"
                    ><i class="iconfont icon-shangchuanshipin1"></i
                    >拍摄视频</van-button
                  >
                </van-uploader>
              </p>
            </li>
          </div>
          <div
            v-if="
              AnswerSheetList &&
                AnswerSheetList.length > 0 &&
                AnswerSheetList.filter(s => s.EQT_ID == QuestionInfo.EQT_ID)
                  .length < QuestionInfo.InitNum
            "
          >
            <li
              v-for="n in QuestionInfo.InitNum -
                AnswerSheetList.filter(s => s.EQT_ID == QuestionInfo.EQT_ID)
                  .length"
              :key="QuestionInfo.EQT_ID + n"
            >
              <p>
                <label for=""
                  >{{ QuestionInfo.TypeName }}({{
                    chin_list[
                      AnswerSheetList.filter(
                        s => s.EQT_ID == QuestionInfo.EQT_ID
                      ).length +
                        n -
                        1
                    ]
                  }})</label
                >
                <span class="refer">
                  <model-list-select
                    :list="
                      QuestionInfo.ExamQuestions.filter(
                        s =>
                          AnswerSheetList.filter(a => a.EQ_ID == s.EQ_ID)
                            .length == 0
                      )
                    "
                    v-model="uploader[QuestionInfo.EQT_ID + '#' + n]"
                    :placeholder="'请选择' + QuestionInfo.TypeName"
                    option-value="EQ_ID"
                    option-text="Question"
                  ></model-list-select>
                </span>
              </p>
              <p>
                <span
                  class="danger"
                  v-if="
                    new Date(
                      ExamFromInfo.ExamTime.ExamEndDate.replace(/-/g, '/')
                    ) > new Date()
                  "
                >
                  视频未上传
                </span>
                <span class="warning" v-else>
                  上传时间已结束，禁止上传视频！
                </span>
                <van-uploader
                  :max-count="1"
                  :before-read="beforeRead"
                  capture="camera"
                  :name="
                    '0|' + uploader[QuestionInfo.EQT_ID + '#' + n] + '|' + EF_ID
                  "
                  accept="video/*"
                  v-if="
                    IsSub == 0 &&
                      uploader[QuestionInfo.EQT_ID + '#' + n] != undefined &&
                      new Date(
                        ExamFromInfo.ExamTime.ExamEndDate.replace(/-/g, '/')
                      ) > new Date()
                  "
                >
                  <van-button type="info" round size="small"
                    ><i class="iconfont icon-shangchuanshipin1"></i
                    >拍摄视频</van-button
                  >
                </van-uploader>
              </p>
            </li>
          </div>
        </div>
        <div
          v-if="
            ExamPatternList &&
              ExamPatternList.filter(
                s =>
                  s.EQT_ID != 1 &&
                  s.EQT_ID != 6 &&
                  s.EQT_ID != 10 &&
                  s.EQT_ID != 24 &&
                  s.EQT_ID != 23 &&
                  s.EQT_ID != 30
              )
          "
        >
          <div
            v-for="PatternInfo in ExamPatternList.filter(
              s =>
                s.EQT_ID != 1 &&
                s.EQT_ID != 6 &&
                s.EQT_ID != 10 &&
                s.EQT_ID != 23 &&
                s.EQT_ID != 24 &&
                s.EQT_ID != 30
            )"
            :key="PatternInfo.EP_ID"
          >
            <div v-if="PatternInfo.IsRandom == 1">
              <li
                v-for="n in PatternInfo.SubmitNum"
                :key="PatternInfo.EP_ID + n"
              >
                <p
                  v-if="
                    !AnswerSheetList ||
                      AnswerSheetList.length == 0 ||
                      AnswerSheetList.filter(
                        s =>
                          s.ExamQuestionType.EQT_ID ==
                          PatternInfo.ExamQuestionType.EQT_ID
                      ).length < n
                  "
                >
                  <label for=""
                    >{{ PatternInfo.ExamQuestionType.TypeName }}({{
                      chin_list[n - 1]
                    }})</label
                  >
                  <van-button
                    type="info"
                    plain
                    round
                    size="small"
                    @click="RandomQuestion(PatternInfo.EP_ID)"
                    >点击查看考试内容</van-button
                  >
                </p>
                <div
                  v-if="
                    AnswerSheetList &&
                      AnswerSheetList.length > 0 &&
                      AnswerSheetList.filter(
                        s =>
                          s.ExamQuestionType.EQT_ID ==
                          PatternInfo.ExamQuestionType.EQT_ID
                      ).length >= n &&
                      AnswerSheetList.filter(
                        s =>
                          s.ExamQuestionType.EQT_ID ==
                          PatternInfo.ExamQuestionType.EQT_ID
                      )[n - 1].Answer == ''
                  "
                >
                  <p>
                    <label for=""
                      >{{
                        AnswerSheetList.filter(
                          s =>
                            s.ExamQuestionType.EQT_ID ==
                            PatternInfo.ExamQuestionType.EQT_ID
                        )[n - 1].ExamQuestionType.TypeName
                      }}({{ chin_list[n - 1] }})</label
                    >
                    <span class="refer">
                      {{
                        AnswerSheetList.filter(
                          s =>
                            s.ExamQuestionType.EQT_ID ==
                            PatternInfo.ExamQuestionType.EQT_ID
                        )[n - 1].View_ExamQuestion.Question
                      }}
                    </span>
                    <van-button
                      type="primary"
                      plain
                      size="small"
                      v-if="
                        AnswerSheetList.filter(
                          s =>
                            s.ExamQuestionType.EQT_ID ==
                            PatternInfo.ExamQuestionType.EQT_ID
                        )[n - 1].View_ExamQuestion.MusicType == 2 &&
                          AnswerSheetList.filter(
                            s =>
                              s.ExamQuestionType.EQT_ID ==
                              PatternInfo.ExamQuestionType.EQT_ID
                          )[n - 1].View_ExamQuestion.MusicScore != ''
                      "
                      @click="
                        ShowMusicScore(
                          AnswerSheetList.filter(
                            s =>
                              s.ExamQuestionType.EQT_ID ==
                              PatternInfo.ExamQuestionType.EQT_ID
                          )[n - 1].View_ExamQuestion.MusicScore
                        )
                      "
                      >查看曲谱</van-button
                    >
                    <van-button
                      type="primary"
                      plain
                      size="small"
                      v-if="
                        AnswerSheetList.filter(
                          s =>
                            s.ExamQuestionType.EQT_ID ==
                            PatternInfo.ExamQuestionType.EQT_ID
                        )[n - 1].View_ExamQuestion.MusicType == 3 &&
                          AnswerSheetList.filter(
                            s =>
                              s.ExamQuestionType.EQT_ID ==
                              PatternInfo.ExamQuestionType.EQT_ID
                          )[n - 1].View_ExamQuestion.MusicScore != ''
                      "
                      :url="
                        AnswerSheetList.filter(
                          s =>
                            s.ExamQuestionType.EQT_ID ==
                            PatternInfo.ExamQuestionType.EQT_ID
                        )[n - 1].View_ExamQuestion.MusicScore
                      "
                      >查看视频</van-button
                    >
                    <van-button
                      type="primary"
                      plain
                      size="small"
                      v-if="
                        AnswerSheetList.filter(
                          s =>
                            s.ExamQuestionType.EQT_ID ==
                            PatternInfo.ExamQuestionType.EQT_ID
                        )[n - 1].View_ExamQuestion.MusicType == 1 &&
                          AnswerSheetList.filter(
                            s =>
                              s.ExamQuestionType.EQT_ID ==
                              PatternInfo.ExamQuestionType.EQT_ID
                          )[n - 1].View_ExamQuestion.MusicScore != ''
                      "
                      :url="
                        AnswerSheetList.filter(
                          s =>
                            s.ExamQuestionType.EQT_ID ==
                            PatternInfo.ExamQuestionType.EQT_ID
                        )[n - 1].View_ExamQuestion.MusicScore
                      "
                      >查看视频</van-button
                    >
                  </p>
                  <p>
                    <span
                      v-if="
                        AnswerSheetList &&
                          new Date(
                            AnswerSheetList.filter(
                              s =>
                                s.ExamQuestionType.EQT_ID ==
                                PatternInfo.ExamQuestionType.EQT_ID
                            )[n - 1].EndTime.replace(/-/g, '/')
                          ) > new Date()
                      "
                      class="warning"
                    >
                      视频未上传
                      <!-- <van-count-down :time="(new Date(AnswerSheetList.filter(s=>s.ExamQuestionType.EQT_ID==PatternInfo.ExamQuestionType.EQT_ID)[n-1].EndTime.replace(/-/g, '/')).getTime()) - (new Date().getTime()) " /> -->
                    </span>
                    <span v-else class="warning">
                      上传时间已结束，禁止上传视频！
                    </span>
                    <van-uploader
                      :max-count="1"
                      v-if="
                        IsSub == 0 &&
                          new Date(
                            AnswerSheetList.filter(
                              s =>
                                s.ExamQuestionType.EQT_ID ==
                                PatternInfo.ExamQuestionType.EQT_ID
                            )[n - 1].EndTime.replace(/-/g, '/')
                          ) > new Date()
                      "
                      :before-read="beforeRead"
                      capture="camera"
                      :name="
                        AnswerSheetList.filter(
                          s =>
                            s.ExamQuestionType.EQT_ID ==
                            PatternInfo.ExamQuestionType.EQT_ID
                        )[n - 1].EAS_ID + '|0|0'
                      "
                      accept="video/*"
                    >
                      <van-button type="info" round size="small"
                        ><i class="iconfont icon-shangchuanshipin1"></i
                        >拍摄视频</van-button
                      >
                    </van-uploader>
                  </p>
                </div>
                <div
                  v-if="
                    AnswerSheetList &&
                      AnswerSheetList.length > 0 &&
                      AnswerSheetList.filter(
                        s =>
                          s.ExamQuestionType.EQT_ID ==
                          PatternInfo.ExamQuestionType.EQT_ID
                      ).length >= n &&
                      AnswerSheetList.filter(
                        s =>
                          s.ExamQuestionType.EQT_ID ==
                          PatternInfo.ExamQuestionType.EQT_ID
                      )[n - 1].Answer != ''
                  "
                >
                  <p>
                    <label for=""
                      >{{
                        AnswerSheetList.filter(
                          s =>
                            s.ExamQuestionType.EQT_ID ==
                            PatternInfo.ExamQuestionType.EQT_ID
                        )[n - 1].ExamQuestionType.TypeName
                      }}({{ chin_list[n - 1] }})</label
                    >

                    <span class="refer">
                      {{
                        AnswerSheetList.filter(
                          s =>
                            s.ExamQuestionType.EQT_ID ==
                            PatternInfo.ExamQuestionType.EQT_ID
                        )[n - 1].View_ExamQuestion.Question
                      }}
                    </span>
                  </p>
                  <p>
                    <span class="gray">
                      <van-loading
                        size="3.2vw"
                        color="#1989fa"
                        type="spinner"
                        v-if="
                          AnswerSheetList.filter(
                            s =>
                              s.ExamQuestionType.EQT_ID ==
                              PatternInfo.ExamQuestionType.EQT_ID
                          )[n - 1].Similarity == 0
                        "
                        vertical
                        ><span class="small">人脸识别中...</span></van-loading
                      >
                      <van-tag
                        type="success"
                        v-if="
                          AnswerSheetList.filter(
                            s =>
                              s.ExamQuestionType.EQT_ID ==
                              PatternInfo.ExamQuestionType.EQT_ID
                          )[n - 1].Similarity >= 0.7 &&
                            AnswerSheetList.filter(
                              s =>
                                s.ExamQuestionType.EQT_ID ==
                                PatternInfo.ExamQuestionType.EQT_ID
                            )[n - 1].Similarity <= 1
                        "
                      >
                        <h5>
                          相似度{{
                            Number(
                              AnswerSheetList.filter(
                                s =>
                                  s.ExamQuestionType.EQT_ID ==
                                  PatternInfo.ExamQuestionType.EQT_ID
                              )[n - 1].Similarity * 100
                            ).toFixed()
                          }}%
                        </h5>
                        <h5>识别通过</h5>
                      </van-tag>
                      <van-tag
                        type="warning"
                        v-if="
                          AnswerSheetList.filter(
                            s =>
                              s.ExamQuestionType.EQT_ID ==
                              PatternInfo.ExamQuestionType.EQT_ID
                          )[n - 1].Similarity > 0 &&
                            AnswerSheetList.filter(
                              s =>
                                s.ExamQuestionType.EQT_ID ==
                                PatternInfo.ExamQuestionType.EQT_ID
                            )[n - 1].Similarity < 0.7
                        "
                      >
                        <h5>
                          相似度{{
                            Number(
                              AnswerSheetList.filter(
                                s =>
                                  s.ExamQuestionType.EQT_ID ==
                                  PatternInfo.ExamQuestionType.EQT_ID
                              )[n - 1].Similarity * 100
                            ).toFixed()
                          }}%
                        </h5>
                        <h5>未通过</h5>
                      </van-tag>
                      <van-tag
                        type="danger"
                        v-if="
                          AnswerSheetList.filter(
                            s =>
                              s.ExamQuestionType.EQT_ID ==
                              PatternInfo.ExamQuestionType.EQT_ID
                          )[n - 1].Similarity > 1
                        "
                      >
                        <h5>识别失败！</h5>
                        <h5>未通过</h5>
                      </van-tag>
                    </span>
                    <van-button
                      plain
                      type="info"
                      @click="
                        Viewvideo(
                          AnswerSheetList.filter(
                            s =>
                              s.ExamQuestionType.EQT_ID ==
                              PatternInfo.ExamQuestionType.EQT_ID
                          )[n - 1]
                        )
                      "
                      round
                      size="small"
                      ><i class="iconfont icon-shangchuanshipin"></i
                      >查看视频</van-button
                    >
                    <van-uploader
                      :max-count="1"
                      v-if="
                        IsSub == 0 &&
                          new Date(
                            AnswerSheetList.filter(
                              s =>
                                s.ExamQuestionType.EQT_ID ==
                                PatternInfo.ExamQuestionType.EQT_ID
                            )[n - 1].EndTime.replace(/-/g, '/')
                          ) > new Date()
                      "
                      :before-read="beforeRead"
                      capture="camera"
                      :name="
                        AnswerSheetList.filter(
                          s =>
                            s.ExamQuestionType.EQT_ID ==
                            PatternInfo.ExamQuestionType.EQT_ID
                        )[n - 1].EAS_ID + '|0|0'
                      "
                      accept="video/*"
                    >
                      <van-button type="primary" round size="small"
                        ><i class="iconfont icon-shangchuanshipin1"></i
                        >重新拍摄</van-button
                      >
                    </van-uploader>
                  </p>
                </div>
              </li>
            </div>
          </div>
        </div>
      </ul>
    </div>

    <div class="upvbtn" v-if="IsSub == 0">
      <van-button
        @click="SubAllAnswer"
        block
        color="linear-gradient(to right, #ff6034, #ee0a24)"
        ><i class="iconfont icon-shangchuanshipin1"></i>
        确认上传全部视频</van-button
      >
    </div>
    <div class="upvbtn" v-if="IsSub == 1">
      <!-- <van-button v-if="AnswerSheetList&&AnswerSheetList.filter(s=>s.Similarity==0).length>0" type="info" disabled class="disabled">视频已上传完成，请稍候查询人脸识别结果！</van-button>

            <van-button v-if="AnswerSheetList&&AnswerSheetList.filter(s=>s.Similarity==0).length==0" type="primary" disabled>已完成线上考试</van-button> -->

      <van-button type="primary" disabled>已完成线上考试</van-button>
    </div>
    <van-overlay :show="pshow">
      <div class="UploadVideo">
        <van-circle v-model="currentRate" :text="UpText" />
        <p>
          文件正在保存...<br /><span class="warning">
            <van-icon name="warning-o" />
            请勿关闭当前页面或熄屏，否则将导致文件保存失败！
          </span>
        </p>
      </div>
    </van-overlay>
    <van-dialog
      v-model="vshow"
      v-if="vshow"
      :title="AnswerInfo.View_ExamQuestion.Question"
      show-button
    >
      <video
        :src="
          AnswerInfo.Similarity == 0
            ? AnswerInfo.Answer
            : AnswerInfo.FormatAnswer
        "
        controls
        width="100%"
        height="300"
      ></video>
      <div class="upvoideoinfo">
        <!-- <p>
                    上传时间：{{AnswerInfo.SubTime}}
                </p> -->
      </div>
    </van-dialog>
    <van-dialog
      v-model="showAllSub"
      title="提交确认"
      show-cancel-button
      :confirm-button-text="buttontext"
      :confirm-button-color="buttoncolor"
      :before-close="beforeClose"
    >
      <p>
        您确定要上传所有的视频吗？<strong style="color: red"
          >上传以后将不能进行修改</strong
        >，您确定要上传吗？
      </p>
    </van-dialog>

    <van-dialog
      v-model="SeleBook"
      title="选择教材，选择以后将不能更改，请谨慎选择"
      confirm-button-text="确定"
      :before-close="beforeSelectBook"
    >
      <p v-for="item in Books" :key="item.TB_ID" style="padding: 15px 10px">
        <van-button
          :type="TB_ID == item.TB_ID ? 'primary' : 'default'"
          plain
          hairline
          @click="TB_ID = item.TB_ID"
          >{{ item.BookName }}</van-button
        >
      </p>
    </van-dialog>
    <video ref="upfile" style="display: none" width="0" height="0"></video>
  </div>
</template>

<script>
import TopNavBar from "@/components/TopNavBar.vue";
import Ticket from "@/components/Ticket.vue";
import oss from "@/Utils/oss.js";
import { GetSTSToken } from "@/api/public";
import {
  ExamFromPatternList,
  GetExamFormInfo,
  RandomQuestion,
  GetAnswerSheetList,
  AddExamAnswerSheetInfo,
  UpdateExamAnswerSheetInfo,
  GetExamQuestionList,
  ResetAnswerRecord,
  SubAnswer,
  GetExamTextBookList,
  SelectTextBook
} from "@/api/exam";
import { ModelListSelect } from "vue-search-select";
import "vue-search-select/dist/VueSearchSelect.css";
import { ImagePreview, Dialog, Toast } from "vant";

export default {
  components: {
    TopNavBar,
    Ticket,
    ModelListSelect
  },
  data() {
    return {
      TB_ID: 0,
      buttoncolor: "",
      buttontext: "5秒后确认",
      subState: false,
      showAllSub: false,
      SeleBook: false,
      IsSub: 0,
      task: null,
      vshow: false,
      active: 0,
      value: 1,
      par: 0,
      Books: null,
      pshow: false,
      currentRate: 0,
      UpText: "",
      ExamFromInfo: null,
      ExamPatternList: null,
      AnswerSheetList: null,
      IsRandom: false,
      EF_ID: 0,
      AnswerInfo: null,
      QuestionList: null,
      Questions: [],
      option: [
        { text: "点击选择上传曲目名称", value: 1 },
        { text: "乐理基础知识2", value: 2 },
        { text: "乐理基础知识3", value: 3 }
      ],
      uploader: [],
      chin_list: ["一", "二", "三", "四", "五", "六", "七", "八", "九", "十"]
    };
  },
  created() {
    if (this.$route.query.EF_ID != undefined && this.$route.query.EF_ID > 0) {
      this.EF_ID = this.$route.query.EF_ID;
      this.GetExamFormInfo(this.EF_ID);
      this.ExamFromPatternList(this.EF_ID);
      let ID = this.EF_ID;
      // this.GetAnswerSheetList();
      let that = this;
      Dialog.alert({
        title: "温馨提示",
        message: `<p>考试的视频需要在60分钟以内完成拍摄、上传、并提交，请您在视频上传完成后点击完成视频上传</p><br><p><h2 class='danger'>录制演奏（演唱）前都必须报幕!</h2><img src=\"${require("@/assets/pv01.png")}\" width=\"98%\"></p><br><p><h2 class='danger'>必须全景横屏录制!</h2><img src=\"${require("@/assets/pv02.png")}\" width=\"98%\"></p>`,
        beforeClose(action, done) {
          if (action === "confirm") {
            ResetAnswerRecord({ EF_ID: ID })
              .then(res => {
                done();
                if (res.Msg == "IsSub") {
                  that.IsSub = 1;
                  that.GetAnswerSheetList();
                }
                that.$refs.timer.start();
              })
              .catch(() => {
                location.reload();
              });
          } else {
            done(false);
          }
        }
      });
    } else {
      this.$router.push("/ExamList");
    }
  },
  methods: {
    getNames(object, name) {
      var values = [];
      for (var property in object)
        values.push(
          this.Questions.find(f => f.EQ_ID == object[property]).Question
        );
      console.log(
        "🚀 ~ file: ExamOnline.vue ~ line 746 ~ getNames ~ values",
        values.indexOf(name)
      );

      return values;
    },
    getObjectValues(object) {
      var values = [];
      for (var property in object) values.push(object[property]);
      return values;
    },
    finish() {
      let that = this;
      Dialog.alert({
        title: "提示",
        message: "本次操作时间已到，系统将重置您未提交的操作",
        beforeClose(action, done) {
          if (action === "confirm") {
            ResetAnswerRecord({ EF_ID: that.EF_ID })
              .then(res => {
                done();
                if (res.Msg == "IsSub") {
                  that.IsSub = 1;
                } else {
                  that.$refs.timer.reset();
                  that.$refs.timer.start();
                }
                that.GetAnswerSheetList();
              })
              .catch(() => {
                // location.reload();
              });
          } else {
            done(false);
          }
        }
      });
    },
    ShowMusicScore(MusicScore) {
      let imgList = MusicScore.split(",");
      if (imgList.length > 0) {
        ImagePreview({ images: imgList, closeable: true });
      }
    },

    Viewvideo(info) {
      this.AnswerInfo = info;
      this.vshow = true;
    },
    beforeRead(file, EF_ID) {
      let parm = EF_ID.name.split("|");
      if (parm[2] == "undefined") {
        this.$toast.fail({ message: "考生信息不正确，请刷新重试" });
        return;
      }
      if (parm[1] == "undefined") {
        this.$toast.fail({ message: "请选择上传曲目名称" });
        return;
      }
      if (parm.length != 3) {
        this.$toast.fail({ message: "参数不正确，请重试" });
        return;
      }
      if (parm[0] == "0") {
        AddExamAnswerSheetInfo({ EF_ID: parm[2], EQ_ID: parm[1] }).then(res => {
          this.SubAnswer(res.OtherMsg.EAS_ID, parm[1], file);
        });
      } else {
        this.SubAnswer(parm[0], parm[1], file);
      }
    },
    GetExamQuestionList(MID, GID, TB_ID) {
      GetExamQuestionList({ MID: MID, GID: GID, TB_ID: TB_ID }).then(res => {
        console.log("res :>> ", res);
        this.QuestionList = [];
        res.listData.forEach(item => {
          if (item.ExamQuestions != null && item.ExamQuestions.length > 0) {
            this.QuestionList.push(item);
            this.Questions = [...this.Questions, ...item.ExamQuestions];
          }
        });
        console.log("this.QuestionList :>> ", this.QuestionList);
        console.log(
          "🚀 ~ file: ExamOnline.vue ~ line 817 ~ GetExamQuestionList ~ Questions",
          this.Questions
        );
      });
    },
    ExamFromPatternList(EF_ID) {
      if (!EF_ID || EF_ID == 0) {
        this.$toast.fail({ message: "请选择要上传考试视频的报名信息" });
        return;
      }
      ExamFromPatternList({ EF_ID: EF_ID }).then(res => {
        this.ExamPatternList = res.listData;
      });
    },
    GetExamFormInfo(EF_ID) {
      GetExamFormInfo({ EF_ID: EF_ID })
        .then(res => {
          this.ExamFromInfo = res.item;
          if (res.item.TB_ID == 0) {
            this.GetExamTextBookList();
          }
          console.log("this.Books :>> ", this.Books);
          if (res.item.TB_ID != 0 || !this.Books) {
            this.GetExamQuestionList(
              res.item.MID,
              res.item.GID,
              res.item.TB_ID
            );
          }
        })
        .catch(err => {});
    },
    GetExamTextBookList() {
      GetExamTextBookList({ MID: this.ExamFromInfo.MID, IsSub: 1 }).then(
        res => {
          this.Books = res.listData;
          if (this.Books && this.Books.length > 0) {
            this.SeleBook = true;
          }
        }
      );
    },
    RandomQuestion(EP_ID) {
      if (this.IsRandom) {
        this.$toast.fail({ message: "正在抽取，请稍等" });
        return;
      }
      this.IsRandom = true;
      RandomQuestion({ EF_ID: this.$route.query.EF_ID, EP_ID: EP_ID })
        .then(res => {
          this.$toast.success({
            message:
              "您的抽考题是《" +
              res.item.View_ExamQuestion.Question +
              "》，请您尽快录制上传"
          });
          this.GetAnswerSheetList();
          this.IsRandom = false;
        })
        .catch(err => {
          console.log("err :>> ", err);
          this.IsRandom = false;
        });
    },
    GetAnswerSheetList() {
      GetAnswerSheetList({ EF_ID: this.$route.query.EF_ID }).then(res => {
        this.AnswerSheetList = res.listData;
      });
    },
    SubAnswer(EAS_ID, EQ_ID, file) {
      let that = this;
      try {
        var vu = URL.createObjectURL(file);
        const video = document.createElement("video");
        video.src = vu;
        video.addEventListener("loadedmetadata", function() {
          console.log("object :>> ", file.name);
          console.log("file.name.split:>> ", file.name.split("."));
          if (file.name.split(".").length != 2) {
            Toast.fail({ message: "请上传正确的文件" });
            return;
          }
          if (this.videoWidth && this.videoHeight) {
            // if (this.videoWidth < this.videoHeight) {
            //     Toast.fail({ message: '录制的视频需要横屏录制' });
            //     return;
            // }
            // Toast.fail({ message: `视频高${this.videoHeight},宽${this.videoWidth},符合要求` });
            that.uploadFiles(file, EAS_ID, EQ_ID);
          } else {
            Dialog.confirm({
              title: "警告",
              message:
                "您录制的视频不符合要求，如果继续上传有可能会影响您的成绩，你要继续上传吗？"
            })
              .then(() => {
                that.uploadFiles(file, EAS_ID, EQ_ID);
              })
              .catch(() => {
                return;
              });
          }
        });
      } catch (error) {
        Dialog.confirm({
          title: "提示",
          message:
            "请您再次确认您录制的视频是否符合录制要求，如果不符合请重新录制，如果您要继续保存当前视频有可能会影响您的成绩，您要继续保存吗？"
        })
          .then(() => {
            that.uploadFiles(file, EAS_ID, EQ_ID);
          })
          .catch(() => {
            return;
          });
      }
    },
    uploadFiles(file, EAS_ID, EQ_ID) {
      GetSTSToken().then(res => {
        this.pshow = true;
        let show = this;
        var ss = oss
          .ossUploadFile(
            {
              region: res.OtherMsg.Region,
              accessKeyId: res.OtherMsg.AccessKeyId,
              accessKeySecret: res.OtherMsg.AccessKeySecret,
              bucket: res.OtherMsg.BucketName,
              stsToken: res.OtherMsg.SecurityToken,
              file: file
            },
            function(val) {
              show.pshow = val;
            },
            function(val) {
              show.currentRate = val;
              show.UpText = "" + val + "%";
            }
          )
          .then(res => {
            let url = res.OssVal.res.requestUrls[0];
            let Answer = {
              EAS_ID: EAS_ID,
              Answer: url.split("?")[0],
              EQ_ID: EQ_ID
            };
            UpdateExamAnswerSheetInfo(Answer).then(resp => {
              this.$toast.success({ message: "视频保存成功" });
              this.GetAnswerSheetList();
              return;
            });
          });
      });
    },
    SubAllAnswer() {
      if (
        !this.AnswerSheetList ||
        this.AnswerSheetList.filter(s => s.Answer != "").length <
          (this.ExamPatternList ? this.ExamPatternList.length : 0) +
            (this.QuestionList ? this.QuestionList.length : 0)
      ) {
        this.$toast.fail({ message: "您还没有录制完所有的视频，不能提交" });
        return;
      }
      this.showAllSub = true;
      let times = 5;
      this.subState = false;
      this.buttoncolor = "#D3D4D6";
      let timer = setInterval(() => {
        times--;
        if (times === 0) {
          this.subState = true;
          this.buttontext = "确认提交";
          this.buttoncolor = "#ee0a24";
          clearInterval(timer);
        } else {
          this.buttontext = `${times}秒后确认`;
        }
      }, 1000);
    },
    beforeClose(action, done) {
      if (action === "confirm") {
        if (this.subState === false) {
          done(false);
          return;
        }
        var count =
          (this.ExamPatternList ? this.ExamPatternList.length : 0) +
          (this.QuestionList ? this.QuestionList.length : 0);
        SubAnswer({ EF_ID: this.EF_ID, Count: count })
          .then(res => {
            this.$toast.success({ message: "视频上传成功" });
            this.$refs.timer.reset();
            this.IsSub = 1;
            done();
          })
          .catch(() => {
            done();
          });
      } else {
        done();
      }
    },
    beforeSelectBook(action, done) {
      if (action === "confirm") {
        if (this.TB_ID === 0) {
          this.$toast.fail({ message: "请选择教材" });
          done(false);
          return;
        }
        SelectTextBook({ EF_ID: this.EF_ID, TB_ID: this.TB_ID })
          .then(res => {
            this.$toast.success({ message: "教材选择成功" });
            location.reload();
            done();
          })
          .catch(() => {
            done();
          });
      }
      done(false);
    }
  }
};
</script>

<style>
.enrolllist .examask li {
  display: block;
}
.enrolllist .examask li p {
  display: flex;
  justify-content: space-between;
  padding: 8px 0;
  font-size: 3.2vw;
}
.enrolllist .examask li p label {
  font-weight: bold;
}
.enrolllist .examask li p span.refer {
  width: 60%;
}
.enrolllist .examask li p .refer .ui.search.dropdown > input.search {
  width: auto;
}
.enrolllist .examask li p span.refer .dropdown {
  padding: 8px;
}
.enrolllist .examask li p span.refer .ui.search.dropdown > .text {
  line-height: 1.5;
}
.enrolllist .examask .danger {
  margin: 5px 0;
}
.enrolllist .examask .danger .van-count-down {
  display: initial;
  font-size: 4.8vw;
}
.UploadVideo {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  background: rgba(3, 3, 3, 0.6);
}
.UploadVideo .van-circle {
  position: absolute;
  top: 30%;
  left: 50%;
  margin-left: -50px;
}
.UploadVideo p,
.UploadVideo .van-circle__text {
  color: #fff;
  padding: 15px;
  line-height: 1.5;
  font-size: 4.8vw;
}
.UploadVideo .van-circle__text {
  font-weight: bold;
}
.UploadVideo p span {
  font-size: 3vw;
}
.upvbtn .disabled {
  background: #888;
  color: #fff;
  border: 0;
}
.upvbtn .disabled .van-button__content .van-button__text {
  font-size: 3.6vw;
}
.van-dialog {
  width: 96%;
}
</style>
